module.exports = __webpack_public_path__ + "img/chile.04aea4bd.png";